import { Typography } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { ListRow } from "web_myplann/Shared/Components/ListRow";

type Props = {
	icon: LucideIcon;
	iconColor: string;
	label: string;
	sublabel?: string;
	destructive?: boolean;
	onClick?: () => void;
};

export const PaperworkActionRow: FC<Props> = ({
	icon: Icon,
	iconColor,
	label,
	sublabel,
	destructive,
	onClick,
}) => {
	return (
		<ListRow
			icon={<Icon size={18} color={iconColor} />}
			title={label}
			subtitle={
				sublabel ? (
					<Typography variant="hint">{sublabel}</Typography>
				) : undefined
			}
			destructive={destructive}
			onClick={onClick}
			isLast
		/>
	);
};
